import qs from "qs";

const cancelStayPage = () => {
  const query = qs.stringify({
    populate: ['image']
  });
  return '/cancel-stay-page?' + query;
};

export default cancelStayPage;
